<template>
  <form>
    <div id="div-other-infos" class="vs-con-loading__container">
      <vs-row>
        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
          <p>Náuseas ? &nbsp;</p>
          <vs-switch
            color="dark"
            icon-pack="feather"
            vs-icon-on="icon-check-circle"
            vs-icon-off="icon-slash"
            v-model="data.nausea"
          >
            <span slot="on">Sim</span>
            <span slot="off">Nao</span>
          </vs-switch>
        </vs-col>

        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
          <p>Vômitos ? &nbsp;</p>
          <vs-switch
            color="dark"
            icon-pack="feather"
            vs-icon-on="icon-check-circle"
            vs-icon-off="icon-slash"
            v-model="data.vomiting"
          >
            <span slot="on">Sim</span>
            <span slot="off">Nao</span>
          </vs-switch>
        </vs-col>
      </vs-row>

      <br />

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-textarea label="Atividade física" cols="50" v-model="data.physicalActivity" />
          </div>
        </vs-col>

        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-textarea label="Medicamentos" cols="50" v-model="data.medicines" />
          </div>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-textarea label="Suplementos" cols="50" v-model="data.supplements" />
          </div>
        </vs-col>

        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <div>
            <vs-textarea label="Polivitamínicos" cols="50" v-model="data.multivitamins" />
          </div>
        </vs-col>
      </vs-row>

      <vs-row>      
        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
          <div>
            <vs-textarea label="Hábito intestinal" cols="50" v-model="data.bowelHabits" />
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col vs-type="flex" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button @click="submit">Salvar</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </form>
</template>

<script>
import AppointmentOtherInfosService from "../../../services/AppointmentOtherInfosService";

export default {
  components: {
  },
  props: {
    idAppointment: {
      // type: Number,
      required: true
    },
    idPatient: {
      // type: Number,
      required: true
    },
  },
  data() {
    return {
      data: {
        id: 0,
        idAppointment: 0,
        idPatient: 0,
        bowelHabits: "",
        nausea: false,
        vomiting: false,
        physicalActivity: "",
        medicines: "",
        supplements: "",
        multivitamins: "",
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      isFormUpdated: false,
      defaultDivId: "div-other-infos",
    };
  },
  mounted: function() {
    this.get();
    this.data.idPatient = this.$props.idPatient;
    this.data.idAppointment = this.$props.idAppointment;
  },
  beforeDestroy: function() {
    this.submit();
  },
  methods: {
    async submit() {
      if (this.data.id != null && this.data.id > 0) {
        this.update();
      } else {
        this.create();
      }
    },
    async get() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.$props.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;
      
      var result = await AppointmentOtherInfosService.get(payload);
      if (result.status == 200) {
        if (result.data.result != null) {
          this.data = result.data.result;
        }
      }

      this.closeLoadingDiv(this.defaultDivId);
    },
    async create() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentOtherInfosService.create(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    async update() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentOtherInfosService.update(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>